// extracted by mini-css-extract-plugin
module.exports = {"falafelContainer":"AuditorInfoActionsFalafelMenu_falafelContainer__1YA2K"};